import styled from "styled-components";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { setFontVariant, colorsPalettes } from "@similarweb/styles";
export const UserSettingsWrapper = styled.div`
    width: 100%;
`;

export const AccountSwitcherItem = styled(FlexRow)`
    align-items: center;
    padding: 7px 11px;
    gap: 8px;
    ${setFontVariant("primaryItem", colorsPalettes.carbon[400])}
    &:hover {
        cursor: pointer;
        background-color: ${colorsPalettes.blue[50]};
        ${setFontVariant("primaryItem", colorsPalettes.blue[400])}
        div {
            svg {
                path {
                    fill: ${colorsPalettes.blue[400]};
                }
            }
        }
    }
`;

export const AccountSwitcherWrapper = styled(FlexColumn)`
    border-radius: 4px;
    padding: 8px;
`;

export const AccountTitle = styled(FlexRow)`
    align-items: center;
    padding: 7px 8px;
    gap: 8px;
`;
